export const capitalizeWord = (word: string): string => {
    if(word && word.length>0){
        return word[0].toUpperCase() + word.substring(1)
    } else {
        return ""
    }
}
